<template>
  <div class="layout-loading-wrapper">
    <custom-loading />
  </div>
</template>

<script>
import CustomLoading from '@/components/CustomLoading/index.vue'

export default {
  name: 'LayoutLoading',
  components: {
    CustomLoading,
  },
}
</script>

<style scoped>
.layout-loading-wrapper{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    /* background: #ffffff9c; */
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}
.layout-loading-wrapper .holder {
  position: absolute;
  top: 50vh;
}
</style>
